var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10,10.6c-0.9,0-1.7,0.8-1.7,1.7v1.6c0,0.9,0.8,1.7,1.7,1.7h0.4l2.2,18.5c0.2,1.8,1.7,3.3,3.6,3.3h12.5 c1.9,0,3.5-1.4,3.7-3.3l2.2-18.5H35c0.9,0,1.7-0.8,1.7-1.7v-1.6c0-0.9-0.8-1.7-1.7-1.7h-7.2l-1.3-2.7c0-0.2-0.2-0.3-0.4-0.3h-7.2 c-0.2,0-0.4,0.1-0.5,0.3l-1.2,2.7H10z M31.5,34c-0.1,1.5-1.3,2.6-2.8,2.5H16.2c-1.4,0-2.6-1.1-2.8-2.5l-2.1-18.4h22.4L31.5,34z  M19.1,8.5h6.7l1,2.1h-8.6L19.1,8.5z M35,11.5c0.4,0,0.8,0.4,0.8,0.8v1.6c0,0.4-0.4,0.8-0.8,0.8H10c-0.4,0-0.8-0.4-0.8-0.8v-1.6 c0-0.4,0.4-0.8,0.8-0.8H35z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ECECEC",
    points: "25.8,8.5 19.1,8.5 18.2,10.6 26.8,10.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M10,11.5c-0.4,0-0.8,0.4-0.8,0.8v1.6c0,0.4,0.4,0.8,0.8,0.8h25c0.4,0,0.8-0.4,0.8-0.8v-1.6 c0-0.4-0.4-0.8-0.8-0.8H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M11.3,15.6L13.4,34c0.2,1.4,1.4,2.5,2.8,2.5h12.5c1.5,0.1,2.7-1,2.8-2.5l2.2-18.4H11.3z M17.2,33.9 c-0.2,0-0.4-0.3-0.4-0.5V18c0-0.2,0.2-0.5,0.4-0.5c0.3,0,0.5,0.2,0.5,0.5v15.4C17.7,33.7,17.5,33.9,17.2,33.9z M22.5,33.9 c-0.3,0-0.5-0.2-0.5-0.5V18c0-0.3,0.2-0.5,0.5-0.5c0.2,0,0.4,0.3,0.4,0.5v15.4C22.9,33.6,22.7,33.9,22.5,33.9z M27.8,33.9 c-0.3,0-0.5-0.2-0.5-0.5V18c0-0.3,0.2-0.5,0.5-0.5c0.2,0,0.4,0.3,0.4,0.5v15.4C28.2,33.6,28,33.9,27.8,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M17.7,18c0-0.3-0.2-0.5-0.5-0.5c-0.2,0-0.4,0.3-0.4,0.5v15.4c0,0.2,0.2,0.5,0.4,0.5c0.3,0,0.5-0.2,0.5-0.5 V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M22.9,18c0-0.2-0.2-0.5-0.4-0.5c-0.3,0-0.5,0.2-0.5,0.5v15.4c0,0.3,0.2,0.5,0.5,0.5c0.2,0,0.4-0.3,0.4-0.5 V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M28.2,18c0-0.2-0.2-0.5-0.4-0.5c-0.3,0-0.5,0.2-0.5,0.5v15.4c0,0.3,0.2,0.5,0.5,0.5c0.2,0,0.4-0.3,0.4-0.5 V18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.4fae6fe13dfcd55dc52d3a574d8d4542.svg";
export { ForwardRef as ReactComponent };